(() => {
  const originalFetch = window.fetch;

  // --- tiny debounce ---
  const debounce = (fn, ms = 150) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  // --- wait for UpCart API to exist ---
  function waitForUpCart(maxMs = 3000, step = 100) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      (function tick(){
        if (typeof window.upcartRefreshCart === 'function') return resolve();
        if (Date.now() - start >= maxMs) return reject(new Error('UpCart API not ready'));
        setTimeout(tick, step);
      })();
    });
  }

  const triggerUpCartRefresh = debounce(async () => {
    try {
      await waitForUpCart();
      window.upcartRefreshCart();
      // console.log('[UpCart] refreshed');
    } catch (e) {
      // console.warn('[UpCart] not ready in time', e);
    }
  }, 200);

  // --- patch fetch ---
  window.fetch = async function(input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    const method = (init?.method || 'GET').toUpperCase();

    const isCartPost =
      !!url &&
      method === 'POST' &&
      /\/cart\/(add|update|change|clear)(\.js)?$/i.test(url);

    const res = await originalFetch.apply(this, arguments);

    if (isCartPost && res && res.ok) {
      queueMicrotask(triggerUpCartRefresh);
    }

    return res;
  };
})();


